import React from "react";
import { Calendar } from "primereact/calendar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Icons } from "assets/icons";

const DateTimePicker = ({
  value,
  onChange,
  showTime = true,
  hourFormat = "12", // "12" or "24"
  dateFormat = "dd/mm/yy",
  placeholder = "Select date & time",
  minDate,
  maxDate,
  disabled = false,
  showSeconds = false,
  className = "",
  label = null,
  infoText = null,
  error = null,
  required = null,
}) => {
  const { info } = Icons || {};
  const now = new Date();

  const isToday =
    value && new Date(value).toDateString() === now.toDateString();

  return (
    <div>
      {label && (
        <label className="w-100 d-flex align-items-center">
          {label}{required && <span className="text-danger">*</span>}
          {infoText && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{infoText}</Tooltip>}
            >
              <img
                src={info}
                alt="info"
                width={15}
                height={15}
                style={{ cursor: "pointer" }}
              />
            </OverlayTrigger>
          )}
        </label>
      )}

      <Calendar
        value={value}
        onChange={(e) => onChange?.(e.value)}
        showTime={showTime}
        hourFormat={hourFormat}
        showSeconds={showSeconds}
        dateFormat={dateFormat}
        placeholder={placeholder}
        minDate={minDate}
        maxDate={maxDate}
        minTime={isToday ? now : null}
        disabled={disabled}
        className={`w-100 ${className}`}
      />
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
};

export default DateTimePicker;
